(() => {
  const DESKTOP_QUERY = '(min-width: 990px)';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  const SCROLL_RANGE_FACTOR = 0.55;

  class OfiyaaPressInstance {
    constructor(root) {
      this.root = root;
      this.cards = Array.from(root.querySelectorAll('[data-parallax-start]'));
      this.intensity = parseFloat(root.dataset.parallaxIntensity) || 1;
      this.desktopQuery = window.matchMedia(DESKTOP_QUERY);
      this.ticking = false;

      this.onScroll = this.onScroll.bind(this);
      this.update = this.update.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);

      this.desktopQuery.addEventListener('change', this.onMediaChange);
      this.onMediaChange();
    }

    destroy() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.desktopQuery.removeEventListener('change', this.onMediaChange);
      this.resetCards();
    }

    onMediaChange() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);

      if (!this.desktopQuery.matches) {
        this.resetCards();
        return;
      }

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.update();
    }

    resetCards() {
      this.cards.forEach((card) => {
        card.style.transform = '';
      });
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    getProgress() {
      const rect = this.root.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const scrollRange = (viewportHeight + rect.height) * SCROLL_RANGE_FACTOR;

      if (scrollRange <= 0) return 0;

      return Math.min(Math.max((viewportHeight - rect.top) / scrollRange, 0), 1);
    }

    update() {
      if (!this.desktopQuery.matches || !this.cards.length) return;

      if (window.matchMedia(REDUCED_MOTION_QUERY).matches) {
        this.resetCards();
        return;
      }

      this.intensity = parseFloat(this.root.dataset.parallaxIntensity) || 1;
      const progress = this.getProgress();

      this.cards.forEach((card) => {
        const start = parseFloat(card.getAttribute('data-parallax-start'));
        const stop = parseFloat(card.getAttribute('data-parallax-stop'));
        const startValue = Number.isFinite(start) ? start : 0;
        const stopValue = Number.isFinite(stop) ? stop : 0;
        const delta = (stopValue - startValue) * this.intensity;
        const offset = startValue + delta * progress;

        card.style.transform = `translate3d(0, ${offset}%, 0)`;
      });
    }
  }

  const instances = new WeakMap();

  function initPress(root) {
    if (!(root instanceof HTMLElement) || instances.has(root)) return;

    instances.set(root, new OfiyaaPressInstance(root));
  }

  function initAll(scope = document) {
    scope.querySelectorAll('ofiyaa-press').forEach(initPress);
  }

  function destroyPress(root) {
    const instance = instances.get(root);
    if (!instance) return;

    instance.destroy();
    instances.delete(root);
  }

  if (!customElements.get('ofiyaa-press')) {
    customElements.define(
      'ofiyaa-press',
      class OfiyaaPress extends HTMLElement {
        connectedCallback() {
          initPress(this);
        }

        disconnectedCallback() {
          destroyPress(this);
        }
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('ofiyaa-press').forEach(destroyPress);
  });
})();
